fragment fullInventorySkus on AdminInventorySkus {
  id
  userId
  comment
  createdAt
  skus {
    skuCode
    type {
      type
      size
      containerId
      colourId
    }
  }
} 